import { assignBm } from '@/entities/bm-assignment';
export async function assignBmAction(agentId, managerId) {
    await assignBm(agentId, managerId);
}
